import React from "react";
import { motion } from "framer-motion";

const HostingIntro = () => (
  <div className="relative pt-24 md:pt-32 pb-8 md:pb-10 flex items-center justify-start pl-16 lg:pl-32 pr-8 lg:pr-16">
    <div className="z-10">
      <motion.h2 
        initial={{ opacity: 0, y: -30 }}
        viewport={{ once: false }}
        whileInView={{ opacity: 1, y: 0, transition: { delay: 0.5 } }}
        className="text-3xl lg:text-5xl font-[TAEBAEKfont] text-black relative after:block after:absolute after:top-[25px] after:-inset-1 after:-skew-y-2 after:bg-red-500 after:opacity-70 after:h-[20px] after:z-[-1]">
        호스팅 및 유지보수
      </motion.h2>
      <div className="text-xl font-[SUIT-Regular] text-gray-700 mt-4">
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          viewport={{ once: false }}
          whileInView={{ opacity: 1, y: 0, transition: { delay: 0.7 } }}
        >
          안정적인 <span className="text-rose-500 font-bold">호스팅 및 유지보수</span> 서비스로
        </motion.div>
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          viewport={{ once: false }}
          whileInView={{ opacity: 1, y: 0, transition: { delay: 1 } }}
        >
          <span className="text-xl font-[SUIT-Regular]">원활한 비즈니스 처리를 지속하겠습니다.</span>
        </motion.div>
      </div>
    </div>
  </div>
);

export default HostingIntro; 